import ReactGA from 'react-ga';

const TRACKING_ID = "YOUR_MEASUREMENT_ID"; // Replace with your Analytics ID
ReactGA.initialize(TRACKING_ID);

export default ReactGA;
